// Module
var code = "<kdatatable table=\"$ctrl.data\" options=\"$ctrl.options\" is-loading=\"$ctrl.loading\" bordered=\"true\" rounded=\"false\" class=\"wf-state-todo-table\" on-data-loaded=\"$ctrl.datatableLoaded()\"> </kdatatable> ";
// Exports
export default code;